/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class BreezeManagementHooksService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Cache the config again.
     * Used after changing environment variables.
     * This should only be used after updating environment variables.
     * It is called automatically after post-deploy.
     * @returns void
     * @throws ApiError
     */
    public d8D628B51569A3Ee91C5C4Afd7Abb2(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/breezyman/cache',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Run Post Deploy jobs.
     * Called by GitHub once containers have been provisioned.
     * Includes running migrations.
     * @returns any Accepted
     * @throws ApiError
     */
    public c33B6E6Bc372Ac27F87Fa61Febe0C53F(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/breezyman/postdeploy',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
